import {
  fetchCustomerTransfers,
  fetchDeviceTransfers,
} from "@/services/dosService";

const initialState = () => ({
  transferRequests: [],
  deviceTransfers: [],
  selectedTransferRequestId: null,
  loading: false,
  error: null,
});

const mutations = {
  FETCH_TRANSFERS_PENDING(state) {
    state.loading = true;
    state.error = null;
  },
  FETCH_TRANSFERS_SUCCESS(state, payload) {
    state.transferRequests = payload;
    state.loading = false;
  },
  FETCH_TRANSFERS_ERROR(state, error) {
    state.error = error;
    state.loading = false;
  },
  FETCH_DEVICE_TRANSFERS_PENDING(state) {
    state.loading = true;
    state.error = null;
  },
  FETCH_DEVICE_TRANSFERS_SUCCESS(state, { deviceTransfers, transferRequestId }) {
    state.deviceTransfers = deviceTransfers;
    state.selectedTransferRequestId = transferRequestId;
    state.loading = false;
  },
  FETCH_DEVICE_TRANSFERS_ERROR(state, error) {
    state.error = error;
    state.loading = false;
  },
  resetState(state) {
    Object.assign(state, initialState());
  },
};

const actions = {
  fetchTransferRequests({ commit }, { userId, filters }) {
    commit("FETCH_TRANSFERS_PENDING");
    return fetchCustomerTransfers(userId, filters)
      .then((data) => {
        commit("FETCH_TRANSFERS_SUCCESS", data);
        return data;
      })
      .catch((error) => {
        commit("FETCH_TRANSFERS_ERROR", error);
        return Promise.reject(error);
      });
  },
  fetchDeviceTransfers({ commit }, { transferRequestId, userId }) {
    commit("FETCH_DEVICE_TRANSFERS_PENDING");
    return fetchDeviceTransfers(transferRequestId, userId)
      .then((data) => {
        commit("FETCH_DEVICE_TRANSFERS_SUCCESS", {
          deviceTransfers: data,
          transferRequestId,
        });
        return data;
      })
      .catch((error) => {
        commit("FETCH_DEVICE_TRANSFERS_ERROR", error);
        return Promise.reject(error);
      });
  },
};

const getters = {
  transferRequests: (state) => state.transferRequests,
  deviceTransfers: (state) => state.deviceTransfers,
  selectedTransferRequestId: (state) => state.selectedTransferRequestId,
  loading: (state) => state.loading,
  error: (state) => state.error,
};

export default {
  state: initialState(),
  mutations,
  actions,
  getters,
  namespaced: true,
};
